import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { trigger, transition, style, animate } from '@angular/animations';
import { CmsPageTypes } from '../landing-footer/cms-page-types';

@Component({
  standalone: false,
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: 0, paddingTop: 0, paddingBottom: 0 }),
        animate(300, style({ height: '*', paddingTop: '*', paddingBottom: '*' }))
      ]),
      transition(':leave', [
        style({ height: '*', paddingTop: '*', paddingBottom: '*' }),
        animate(300, style({ height: 0, paddingTop: 0, paddingBottom: 0 }))
      ])
    ])
  ]
})
export class CookieBannerComponent implements OnInit {
  readonly landingCookiesBanner = $localize`:@@layout-component.landingCookiesBanner:
  This site uses cookies placed by us and third parties to assist you in your navigation of the site,
  collect statistical information, and customize your experience of this site (and show you relevant advertising).`;
  readonly landingCookiesBannerCont = $localize`:@@layout-component.landingCookiesBannerCont:By continuing to browse this site
   you are agreeing to the use of cookies as set out in our `;
  readonly landingCookiesPolicy = $localize`:@@layout-component.landingCookiesPolicy:Cookies Policy`;

  CMS;

  show = false;

  constructor(private readonly cookieService: CookieService, public cms: CmsPageTypes) {}

  ngOnInit() {
    this.CMS = this.cms.code;

    if (localStorage.getItem('isCookiesBannerShown') !== '1') {
      setTimeout(() => {
        this.show = true;
        localStorage.setItem('isCookiesBannerShown', '1');
      }, 1000);
    }
  }

  close() {
    this.show = false;
  }
}
